<template>
  <MenuItem
    v-slot="{ active }"
    :class="[
      'group flex w-full cursor-pointer items-center rounded-md px-3 py-2 text-sm font-medium focus:outline-none focus:ring-0',
    ]"
    @click="select()"
  >
    <div
      :class="[
        item.count !== undefined && 'flex justify-between',
        selected ? 'bg-primary-99 text-primary-60' : 'text-neutral-0',
        selected && active && 'bg-neutral-100 text-primary-60',
        !selected && active && 'bg-primary-99',
      ]"
    >
      <span :class="[selected && 'text-primary-60', 'truncate']">
        {{ item.text }}
      </span>
      <span
        v-if="item.count !== undefined"
        :class="[
          selected ? 'bg-white text-primary-60' : 'bg-neutral-99 group-hover:bg-neutral-99',
          'ml-auto inline-block rounded-full px-3 py-0.5 text-xs',
        ]"
      >
        {{ item.count }}
      </span>
    </div>
  </MenuItem>
</template>

<script lang="ts" setup>
//Components
import { MenuItem } from "@headlessui/vue";

//Types
import type { CategoryItem } from "../CategoryMenu.types";

//Props
withDefaults(
  defineProps<{
    item: CategoryItem;
    selected?: boolean;
  }>(),
  {},
);

//Emits
const emit = defineEmits<{
  (e: "select"): void;
}>();

const select = () => emit("select");
</script>
